<template>
  <div class="filter-modal">
    <label class="filter-modal__trigger" v-b-modal="'modal-search-filters'">
      Filtri
      <vb-icon
        class="filter-modal__trigger-icon"
        :name="'filter'"
        :color="sass('dark')"
        :size="18"
      />
    </label>

    <vb-modal
      :vb_options="{
        id: 'modal-search-filters',
        size: 'xl',
        title: 'Filtra i risultati',
        hide_footer: true,
      }"
    >
      <b-container fluid :key="update_key">
        <!-- Brand filters -->
        <b-row
          v-for="(filter, filter_key) in brand_filters"
          :key="filter_key"
        >
          <b-col md="4" lg="3" xl="2" class="filter-modal__heading-col">
            <div class="filter-modal__heading">
              <vb-icon
                :name="get_filter_heading(filter_key).icon"
                :color="sass('dark')"
                :size="24"
              />
              <span class="filter-modal__heading-text" v-html="get_filter_heading(filter_key).title" />
            </div>
          </b-col>
          <b-col
            sm="6" md="4" lg="3" xl="2"
            class="filter-modal__option-col"
            v-for="(option, option_index) in filter"
            :key="option_index"
          >
            <div class="filter-modal__brand-option">
              <vb-checkbox
                :class="{ disabled: option.amount === 0 }"
                @change="(value) => $emit('filter', { key: filter_key, value })"
                v-model="option.selected"
                :vb_options="{
                  text: `${option.text} (${option.amount})`,
                  value: option.selected,
                }"
              >
                <template #default>
                  <img :src="`assets/images/alpitour/liveat-brands/${option.logo}`" />
                </template>
              </vb-checkbox>
            </div>
          </b-col>
        </b-row>

        <!-- Other filters -->
        <div
          v-for="(filter, filter_key) in non_brand_filters"
          :key="filter_key"
        >
          <hr />
          <b-row>
            <b-col>
              <div class="filter-modal__heading filter-modal__heading--section">
                <vb-icon
                  :name="get_filter_heading(filter_key).icon"
                  :color="sass('dark')"
                  :size="20"
                />
                <span class="filter-modal__heading-text">{{ get_filter_heading(filter_key).title }}</span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="filter-modal__column"> 
                <vb-checkbox
                  v-for="(option, option_index) in filter"
                  :key="option_index"
                  class="filter-modal__option"
                  @change="(value) => $emit('filter', { key: filter_key, value })"
                  v-model="option.selected"
                  :vb_options="{
                    text: `${option.text} ${option.amount > 0 ? `(${option.amount})` : ''}`.toLowerCase(),
                    value: option.selected,
                    disabled: option.amount === 0,
                  }"
                />
              </div>
            </b-col>
          </b-row>
        </div>

        <b-row>
          <b-col class="filter-modal__confirm">
            <vb-button
              @click="$bvModal.hide('modal-search-filters')"
              :vb_options="{ text: 'OK' }"
            />
          </b-col>
        </b-row>
      </b-container>

      <div v-if="filtering" class="filter-modal__loader">
        <loader />
      </div>
    </vb-modal>
  </div>
</template>

<script>
import { get_filter_heading, get_non_brand_filters } from '@alpitour/utilities/results-filters'

export default {
  name: "filter-modal",
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    filtering: {
      type: Boolean,
      default: false,
    },
    update_key: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    brand_filters() {
      return { brand: this.filters.brand || [] }
    },
    non_brand_filters() {
      return get_non_brand_filters(this.filters)
    },
  },
  methods: {
    get_filter_heading,
  },
}
</script>

<style lang="scss" scoped>
.filter-modal {
  &__trigger {
    display: flex;
    align-items: center;
    font-weight: normal;
    margin: 0;
    padding-left: 0 !important;
  }

  &__trigger-icon {
    margin-left: 0.5rem;
  }

  &__heading {
    display: flex;
    align-items: center;

    &--section {
      margin-bottom: $grid-gutter-width/2;
    }
  }

  &__heading-col {
    margin-bottom: $grid-gutter-width/2;
  }

  &__heading-text {
    font-weight: $vb-font-weight-semibold;
    margin-left: 0.5rem;
  }

  &__option-col {
    margin-bottom: $grid-gutter-width/2;
  }

  &__option {
    text-transform: capitalize;
  }

  &__brand-option {
    img {
      margin-left: 0.15rem;
      height: 16px;
      width: auto;
    }

    .disabled {
      filter: grayscale(100);
      pointer-events: none;
    }
  }

  &__column {
    column-count: 2;

    @include media-breakpoint-up(md) {
      column-count: 3;
    }

    @include media-breakpoint-up(lg) {
      column-count: 4;
    }
  }

  &__confirm {
    text-align: center;
    margin-top: $grid-gutter-width;

    @include media-breakpoint-up(lg) {
      text-align: right;
    }
  }

  &__loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba($white, 0.9);
    z-index: 10;
  }
}
</style>
